<template>
  <el-card
    v-if="config"
    class="card-container show"
    shadow="never"
  >
    <CardHeader
      slot="header"
      :item="item"
      :permission="permission"
      :is-edit="isEdit"
      :calling="callingAPI"
      :config="config"
      @edit="() => isEdit = true"
      @cancel="handleCancel"
      @save="handleSave"
    />
    <div
      v-if="item && fields.length > 0"
      style="display: flex;"
      class="menu-content"
    >
      <div
        v-if="groups.length > 0"
        class="menu"
      >
        <el-menu
          :default-active="activeMenu"
          @select="handleSelectMenu"
        >
          <img
            v-if="imageUrl"
            :src="imageUrl"
            class="image-avatar"
            alt=""
          >
          <el-menu-item
            v-for="(group, index) in groups"
            :key="group.key"
            :index="`${index}`"
          >
            <span>{{ group.name }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="content p-xl">
        <h2
          v-if="selectedGroup"
          class="mb-4 text-left"
        >
          {{ selectedGroup.name }}
        </h2>
        <CardForm
          ref="cardForm"
          :key="selectedGroup ? selectedGroup.key : null"
          :form="form"
          :fields="fields"
          :disabled="callingAPI || !isEdit"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import CardHeader from "./components/show/CardHeader.vue";
import CardForm from "./components/show/CardForm.vue";
import commonServices from "@/services/common";
import fileServices from '@/services/file';

import {
  notification,
  convertPayloadData,
  arrayToObject,
  convertConfig
} from "@/utils/common";
import constants from "@/config/constants";
import { objectPer } from "@/utils/permission";

export default {
  name: "SharedShow",
  components: {
    CardHeader,
    CardForm,
  },
  data() {
    return {
      item: null,
      isEdit: false,
      parentId: null,
      form: {},
      callingAPI: false,
      activeMenu: "0",
      imageUrl: ""
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    moduleInfo() {
      console.log(this.$route.meta.module)
      return this.$route.meta.module
    },
    config() {
      const originConfig = this.allConfigs.find((c) => c.id === this.$route.meta.configId);
      return convertConfig(originConfig, this.moduleInfo);
    },
    objectType() {
      return constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
    },
    permission() {
      return objectPer(this.objectType.role_action);
    },
    groups() {
      return (this.config.extra.groups || []).filter((g) => g.fields && g.fields.length > 0).sort((a, b) => a.order - b.order);
    },
    selectedGroup() {
      return this.groups[Number(this.activeMenu)] || null;
    },
    fields() {
      if (!this.selectedGroup) {
        return this.config.extra.fields || [];
      }
      return (this.config.extra.fields || [])
        .filter((f) => this.selectedGroup.fields.includes(f.key))
        .sort((a, b) => a.order - b.order);
    },
  },
  watch: {
    config: "loadData",
  },
  beforeMount() {
    this.loadData();
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    loadData() {
      if (!this.config) {
        return;
      }
      this.loading = true;
      commonServices
        .show(this.config.type, this.$route.params.id)
        .then((response) => {
          this.item = response;
          this.parentId = response.parent_id;
          this.form = JSON.parse(
            JSON.stringify({
              ...arrayToObject(this.config.extra.fields),
              ...response.extra,
            })
          );
          if (response.extra?.file_images?.length) {
            this.getImageUrl(response.extra.file_images[0])
          }
          this.loading = false;
        })
        .catch(() => {
          this.$router.push({ name: this.config.extra.key });
        });
    },

    async getImageUrl(file) {
      try {
        const response = await fileServices.show(file.id)
        this.imageUrl = response.url
      } catch (error) {
        this.imageUrl = ''
      }
    },

    handleCancel() {
      this.isEdit = false;
      this.$refs.cardForm.$refs.form.resetFields();
      this.form = JSON.parse(
        JSON.stringify({
          ...arrayToObject(this.config.extra.fields),
          ...this.item.extra,
        })
      );
    },

    handleSave() {
      this.$refs.cardForm.$refs.form.validate(async (valid) => {
        if (valid) {
          commonServices
            .update(
              this.config.type,
              convertPayloadData(this.config.extra.key, {
                ...this.item,
                parent_id: this.parentId,
                extra: {
                  ...this.item.extra,
                  ...this.form,
                },
              })
            )
            .then(() => {
              this.callingAPI = false;
              notification(
                this,
                "success",
                "update",
                `${this.config.extra.name}`
              );
              this.isEdit = false;
              this.loadData();
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                "update",
                `${this.config.extra.name}`
              );
            });
        }
      });
    },

    handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = "";
    },

    handleSelectMenu(index) {
      this.activeMenu = String(index);
    },
  },
};
</script>

<style lang="scss">
.card-container {
  &.show {
    .el-card__body {
      padding: 0 !important;
      .el-menu {
        height: 100%;
      }
      .image-avatar {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
      .menu-content {
        .menu {
          width: 250px;
          .el-menu-item{
            min-height: 48px;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            span {
              white-space: normal;
            }

            &.is-active {
              color: #2F80ED;
              background-color: #2f81ed2a;
            }
          }
        }
        .content {
          flex: 1;
        }
      }
    }
  }
}
</style>
